import React, { useState, useRef } from 'react'
import "../css/hotelfeedsearchmodal.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

const HotelSearchResults = ({hotelResults, language, totalItems, isLoading, selectedCode, showMoreResults, visible, handleResultClick}) => {
    const containerRef = useRef()

    const scrollToTop = () => {
        if(!containerRef.current) return;
        containerRef.current.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
  return (
    <div className="hotelSearchModalResults mt-2" ref={containerRef}>
        <div className="row">
            <div className="col-12 mb-2">
                <h4>{totalItems === 1 ? `${language}` : 'Results'}</h4>
            </div>
        </div>
        <div className="row">
                <div className="col-12 ">
                {!hotelResults ? null : <p className="hotel-found">{totalItems} hotel{totalItems === 1 ? '' : 's'} found</p>}
                    <table className="table table-hover">
                        <tbody>
                            {hotelResults.slice(0, visible).map((item, index) => (
                                <tr key={index} onClick={() => handleResultClick(item.HotelCode)}>                 
                                <td className={selectedCode === item.HotelCode ? "hotel-modal-active" : ""}> 
                                    <input 
                                        type="radio" 
                                        name="hotelNameRadio"
                                        value={item.HotelName + " - " + item.HotelCode} 
                                        checked={selectedCode === item.HotelCode} 
                                        onChange={() => handleResultClick(item.HotelCode)}
                                    />
                                </td>
                                <td className={selectedCode === item.HotelCode ? "hotel-modal-active" : ""}><label>{item.HotelName} - RID {item.HotelCode}</label></td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                    {visible < totalItems && (
                    <div className="d-flex justify-content-center">
                        <button onClick={showMoreResults} type="button" id="btnModalSubmit" className="btn load-more">{isLoading ? "Loading..." : "Load More"}</button>
                    </div>)}
                    {visible >= totalItems && totalItems > 10 && (
                        <button onClick={scrollToTop} className="btn btn-sm btn-primary rounded-circle scroll-down-button">
                            <FontAwesomeIcon icon={faArrowUp}/>
                        </button>
                    )}
                </div>
            </div>
    </div>
  )
}

export default HotelSearchResults
